import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import Globe from '../globe/Globe';
import { useMarketData } from '../../utils/marketData';
// import type { MarketData } from '../../types';
import { ReactComponent as LogoSvg } from '../../logo_black.svg';

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem;
  margin-bottom: -3rem;
`;

const HeroSection = styled.section`
  text-align: center;
  max-width: 800px;
  margin: 2rem auto 4rem;
`;

const HeroLogo = styled.div`
  margin-bottom: 0rem;
  margin-left: 1.4rem;
  display: flex;
  justify-content: center;
`;

// const Title = styled.div`
//   font-size: 2rem;
//   font-weight: 500;
//   margin-bottom: 1rem;
//   line-height: 1.2;
//   color: #13182a;
// `;

const GlobeSection = styled.section`
  width: 100%;
  height: 100%;
  max-width: 800px;
  margin: 0 auto;
`;

const Cursor = styled.span`
  display: inline-block;
  width: 2px;
  height: 1.5rem;
  background-color: #13182a;
  vertical-align: middle;
  margin-left: 2px;
  animation: blink 0.8s step-end infinite;

  @keyframes blink {
    50% {
      opacity: 0;
    }
  }
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 40px;
  font-size: 1.2rem;
  color: #757575;
`;

const ErrorMessage = styled.div`
  text-align: center;
  padding: 40px;
  font-size: 1.2rem;
  color: #d32f2f;
`;

const HomePage: React.FC = () => {
  // const marketData = marketUtils.getMarketData();
  const { marketData, loading, error } = useMarketData();
  const fullTitle = 'We’ve made it our mission to crack the markets.';
  const [typedTitle, setTypedTitle] = React.useState('');

  React.useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    // only start typing once data is loaded without error
    if (!loading && !error) {
      timeoutId = setTimeout(() => {
        let currentIndex = 0;
        const intervalId = setInterval(() => {
          setTypedTitle(fullTitle.slice(0, currentIndex + 1));
          currentIndex += 1;
          if (currentIndex === fullTitle.length) {
            clearInterval(intervalId);
          }
        }, 60);
      }, 0); // start typing immediately, add delay if needed (500 for 0.5s)
    }
    // always clean up the timeout
    return () => {
      clearTimeout(timeoutId);
    };
  }, [loading, error, fullTitle]);

  if (loading) {
    return <LoadingMessage>Loading market data...</LoadingMessage>;
  }

  if (error) {
    return <ErrorMessage>Error: {error}</ErrorMessage>;
  }

//   return (
    
//     <HomeContainer>
//       <Helmet>
//         <title>Heaviside | Home</title>
//         <meta
//           name="description"
//           content="Heaviside is a next-generation quantitative hedge fund, founded to trade global markets at the highest level."
//         />
//         <meta
//           name="keywords"
//           content="Heaviside, hvside, heaviside capital, hvside capital, heaviside investment, hvside investment, hedge, fund, trading, research, AI-driven models, algorithmic trading, finance, systematic investing, data-driven strategies, high-frequency trading, risk management"
//         />
//         <meta name="author" content="Heaviside Team" />

//       </Helmet>
//       <HeroSection>
//         <HeroLogo>
//           <LogoSvg style={{ height: '100' }} viewBox="30 90 240 100" />
//         </HeroLogo>
//         <Title style={{ fontFamily: 'Garamond', color: '#13182a' }}>
//           {typedTitle}
//           <Cursor />
//         </Title>
//       </HeroSection>

//       <GlobeSection>
//         <Globe markets={marketData} />
//       </GlobeSection>

//       {/* <HeroSection>
//         <Title
//           style={{
//             fontSize: '1.5rem',
//             marginTop: '2rem',
//             fontFamily: 'Garamond',
//             color: '#13182a',
//           }}
//         >
//           We are the next generation — Born with computers, raised on data, and
//           engineered to shape the financial markets.
//         </Title>
//       </HeroSection> */}
//     </HomeContainer>
//   );
// };

  return (
    <HomeContainer>
      <Helmet>
        <title>Heaviside | Home</title>
        <meta name="description" content="Heaviside is a next-generation quantitative hedge fund, founded to trade global markets at the highest level." />
        <meta name="keywords" content="Heaviside, hvside, heaviside capital, hvside capital, heaviside investment, hvside investment, hedge, fund, trading, research, AI-driven models, algorithmic trading, finance, systematic investing, data-driven strategies, high-frequency trading, risk management" />
        <meta name="author" content="Heaviside Team" />
        <meta property="og:url" content="https://hvside.com" />
        <meta property="og:image" content="https://hvside.com/logo_text_svg.svg" />
        <link rel="icon" href="/logo_white.ico" />
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Heaviside",
            "url": "https://hvside.com",
            "logo": "https://hvside.com/logo_text_svg.svg",
            "sameAs": [],
            "description": "Heaviside is a next-generation quantitative hedge fund, built to trade global markets with full autonomy using AI-driven models and statistics.",
            "founder": {
              "@type": "Person",
              "name": "Ste and Xof, the Heaviside Team"
            }
          }
          `}
          </script>
      </Helmet>

        
          <HeroSection>
            <HeroLogo>
              <LogoSvg style={{ height: '100' }} viewBox="30 90 240 100" />
            </HeroLogo>
            <h1 style={{ fontFamily: 'Garamond', color: '#13182a', fontSize: '2rem', fontWeight: 500 }}>
              {typedTitle}
              <Cursor />
            </h1>
          </HeroSection>

          <GlobeSection>
            <Globe markets={marketData} />
          </GlobeSection>
        <p style={{ position: 'absolute', width: '1px', height: '1px', overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap' }}>
          Heaviside is a next-generation quantitative hedge fund, built to trade global markets with full autonomy using AI-driven models and statistics.
        </p>

      </HomeContainer>
  );
};

export default HomePage;
